import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Scale, BookOpen, Lightbulb } from 'lucide-react';
export function Features() {
  return <Section id="analysis" background="white" data-id="element-1">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-2">
        <div data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-4">
            Technical Writing You Can <br data-id="element-5" />
            <span className="text-blue-600" data-id="element-6">Actually Use</span>
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-7">
            Most technical content is either too basic or too complex.{' '}
            <a href="https://dataprixa.com" className="text-blue-600 hover:underline font-medium" data-id="element-8">
              Dataprixa
            </a>{' '}
            focuses on practical guides that work in production. We test what we
            write about and explain things clearly.
          </p>

          <div className="space-y-6" data-id="element-9">
            <div className="flex items-start" data-id="element-10">
              <div className="flex-shrink-0 mt-1" data-id="element-11">
                <CheckCircle2 className="h-6 w-6 text-green-500" data-id="element-12" />
              </div>
              <div className="ml-4" data-id="element-13">
                <h3 className="text-xl font-semibold text-slate-900" data-id="element-14">
                  Technical Accuracy
                </h3>
                <p className="mt-2 text-slate-600" data-id="element-15">
                  We research every article thoroughly and test the code
                  ourselves. No fluff or marketing speak—just clear explanations
                  of how things actually work.
                </p>
              </div>
            </div>

            <div className="flex items-start" data-id="element-16">
              <div className="flex-shrink-0 mt-1" data-id="element-17">
                <Scale className="h-6 w-6 text-blue-500" data-id="element-18" />
              </div>
              <div className="ml-4" data-id="element-19">
                <h3 className="text-xl font-semibold text-slate-900" data-id="element-20">
                  Ethical Data Practices
                </h3>
                <p className="mt-2 text-slate-600" data-id="element-21">
                  We cover the legal side of data collection and explain how to
                  build systems that respect privacy laws. Our guides help you
                  stay compliant with GDPR, CCPA, and other regulations.
                </p>
              </div>
            </div>

            <div className="flex items-start" data-id="element-22">
              <div className="flex-shrink-0 mt-1" data-id="element-23">
                <Lightbulb className="h-6 w-6 text-amber-500" data-id="element-24" />
              </div>
              <div className="ml-4" data-id="element-25">
                <h3 className="text-xl font-semibold text-slate-900" data-id="element-26">
                  Actionable Guidance
                </h3>
                <p className="mt-2 text-slate-600" data-id="element-27">
                  Every article includes working code examples and step-by-step
                  instructions. You can follow along and implement what you
                  learn right away.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="relative" data-id="element-28">
          <div className="absolute -inset-4 bg-gradient-to-r from-blue-100 to-slate-100 rounded-xl transform rotate-2" data-id="element-29"></div>
          <div className="relative bg-white p-8 rounded-xl shadow-xl border border-slate-100" data-id="element-30">
            <div className="flex items-center space-x-3 mb-6 border-b border-slate-100 pb-4" data-id="element-31">
              <BookOpen className="h-5 w-5 text-slate-400" data-id="element-32" />
              <span className="text-sm font-medium text-slate-500 uppercase tracking-wider" data-id="element-33">
                Editorial Standard
              </span>
            </div>
            <blockquote className="text-xl font-medium text-slate-900 italic mb-6" data-id="element-34">
              &quot;
              <a href="https://dataprixa.com" className="text-blue-600 hover:underline" data-id="element-35">
                Dataprixa
              </a>{' '}
              helps developers, researchers, and technical teams understand data
              infrastructure and security through clear, practical
              writing.&quot;
            </blockquote>
            <div className="flex items-center space-x-4" data-id="element-36">
              <div className="h-10 w-10 rounded-full bg-slate-200 flex items-center justify-center font-bold text-slate-600" data-id="element-37">
                DP
              </div>
              <div data-id="element-38">
                <div className="font-semibold text-slate-900" data-id="element-39">
                  The Dataprixa Team
                </div>
                <div className="text-sm text-slate-500" data-id="element-40">Editorial Board</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}